import React from "react";
import { useIntl } from "react-intl";

import { RichText } from "@learningblocks/shared-components/lib/RichText";

import { TableCellProps } from "../types";
import { listCellClass } from "../TableQuestion.css";

export interface ListCellProps extends Pick<
  TableCellProps,
  "cellId" | "text" | "colspan" | "ariaLabel"
> {
  bgColor?: string;
}

export const ListCell: React.FC<ListCellProps> = ({
  cellId,
  text,
  colspan,
  bgColor,
  ariaLabel,
}) => {
  const intl = useIntl();

  const translatedText = text
    ? intl.formatMessage({ id: text, defaultMessage: text })
    : "";

  const translatedAriaLabel = ariaLabel
    ? intl.formatMessage({ id: ariaLabel, defaultMessage: ariaLabel })
    : undefined;

  const style = {
    ...(bgColor && { backgroundColor: bgColor }),
  };

  return (
    <td
      key={cellId}
      className={listCellClass}
      colSpan={colspan ? Number(colspan) : undefined}
      style={style}
      aria-label={translatedAriaLabel}
    >
      <RichText value={translatedText} />
    </td>
  );
};
